import {
    UNMOUNT_SCREEN,
    BLOCK_SCREEN,
    UNBLOCK_SCREEN,
    ACTIVATE_NEXT_BUTTON,
    DEACTIVATE_NEXT_BUTTON,
    GREY_OUT_SCREEN,
    COLOR_IN_SCREEN,
    ENABLE_DOWN_BUTTON,
    DISABLE_DOWN_BUTTON,
    HIGHLIGHT_DOWN_BUTTON,
    DEHIGHLIGHT_DOWN_BUTTON,
    ENABLE_GO_BACK_BUTTON,
    DISABLE_GO_BACK_BUTTON,
    OPEN_READING_REMINDER_POPUP,
    CLOSE_READING_REMINDER_POPUP,
    SET_IS_SCROLL_BUTTON_CLICKED,
    GREY_OUT_OK_BUTTON,
    COLOR_IN_OK_BUTTON,
    ENABLE_TEXT_PANE_SCROLL,
    DISABLE_TEXT_PANE_SCROLL,
    SHOW_LOGOUT_MODAL,
    HIDE_LOGOUT_MODAL,
    SET_CONFIRM_POPUP_VISIBILITY,
    SET_IS_FILE_LOADING_FAILED,
    TOGGLE_POINTER_CLICK,
    SET_POINTER_POSITION,
    TOGGLE_POINTER_VISIBILITY,
    TOGGLE_CIRCLE_BUTTONS,
    TOGGLE_SECONDS_TIMER,
    SET_SECONDS_TIMER,
    SET_NEXT_BUTTON_CLICKABLE,
    SET_CURRENT_LANGUAGE,
    SHOW_HELP_POPUP,
    HIDE_HELP_POPUP,
    OPEN_TRC_PRACTICE_POPUP,
    CLOSE_TRC_PRACTICE_POPUP,
    SHOW_SPINNER,
    HIDE_SPINNER,
    SET_IS_EXTERNAL_URL_SOURCE_PRESENT,
    SET_INITIAL_QUERY_PARAMS,
    SET_BENCHMARK_MODE_URL_STATUS,
    SET_BENCHMARK_ID,
    SET_SHOULD_ENABLE_CAPTIONS,
    SET_SHOULD_DISPLAY_CAPTION,
    SHOW_PAUSE_BUTTON,
    SET_PAUSE_BUTTON_ACTIVE,
    SET_PAUSE_BUTTON_INACTIVE,
    SET_AR_LANGUAGE,
    SHOW_SETTINGS_POPUP,
    HIDE_SETTINGS_POPUP,
} from './screenActions';
import { LOAD_PLAYLIST } from '../playlist/playlistActions';
import { SET_TRC_CONTENT } from '../../trc/trcActions';
import { ASSESSMENT_TYPE } from '../../constants/measure';
import { LANGUAGE } from '../../constants/language';

const FIRST_PLAYLIST_INDEX = 0;

export const defaultState = {
    isNextButtonActive: false,
    isNextButtonClickable: true,
    isScreenBlocked: false,
    isDownButtonEnabled: false,
    isDownButtonHighlighted: false,
    isScreenGreyedOut: false,
    isHelpPopupVisible: false,
    isOkButtonGreyedOut: false,
    isBackButtonActive: false,
    isReadingReminderPopupActive: false,
    isConfirmPopupActive: false,
    isTextPaneScrollEnabled: false,
    isLogoutModalVisible: false,
    fontName: '',
    fontSize: '',
    isFileLoadingFailed: false,
    isAssessmentInstructionEnabled: true,
    isPointerClicked: false,
    pointerPosition: undefined,
    isPointerVisible: false,
    isCircleButtonsVisible: false,
    currentLanguage: LANGUAGE.ENG,
    isTRCPracticePopupActive: false,
    isExternalURLSourcePresent: false,
    initialQueryParams: '',
    isBenchmarkModeEnabled: false,
    arLanguage: 'en',
    benchmarkId: undefined,
    shouldEnableCaptions: false,
    shouldDisplayCaption: false,
    shouldShowPauseButton: false,
    isPauseButtonActive: false,
    isSettingsPopupVisible: false,
};

const screenReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ACTIVATE_NEXT_BUTTON:
            return {
                ...state,
                isNextButtonActive: true,
            };
        case DEACTIVATE_NEXT_BUTTON:
            return {
                ...state,
                isNextButtonActive: false,
            };
        case SET_NEXT_BUTTON_CLICKABLE:
            return {
                ...state,
                isNextButtonClickable: action.isClickable,
            };
        case ENABLE_GO_BACK_BUTTON:
            return {
                ...state,
                isBackButtonActive: true,
            };
        case DISABLE_GO_BACK_BUTTON:
            return {
                ...state,
                isBackButtonActive: false,
            };
        case UNMOUNT_SCREEN:
            return {
                ...defaultState,
                isAssessmentInstructionEnabled: state.isAssessmentInstructionEnabled,
                currentLanguage: state.currentLanguage,
                isExternalURLSourcePresent: state.isExternalURLSourcePresent,
                initialQueryParams: state.initialQueryParams,
                isBenchmarkModeEnabled: state.isBenchmarkModeEnabled,
                benchmarkId: state.benchmarkId,
                shouldEnableCaptions: state.shouldEnableCaptions,
                arLanguage: state.arLanguage,
            };
        case BLOCK_SCREEN:
            return {
                ...state,
                isScreenBlocked: true,
            };
        case UNBLOCK_SCREEN:
            return {
                ...state,
                isScreenBlocked: false,
            };
        case ENABLE_DOWN_BUTTON:
            return {
                ...state,
                isDownButtonEnabled: true,
            };
        case DISABLE_DOWN_BUTTON:
            return {
                ...state,
                isDownButtonEnabled: false,
            };
        case HIGHLIGHT_DOWN_BUTTON:
            return {
                ...state,
                isDownButtonHighlighted: true,
            };
        case DEHIGHLIGHT_DOWN_BUTTON:
            return {
                ...state,
                isDownButtonHighlighted: false,
            };
        case GREY_OUT_OK_BUTTON:
            return {
                ...state,
                isOkButtonGreyedOut: true,
            };
        case COLOR_IN_OK_BUTTON:
            return {
                ...state,
                isOkButtonGreyedOut: false,
            };
        case GREY_OUT_SCREEN:
            return {
                ...state,
                isScreenGreyedOut: true,
            };
        case COLOR_IN_SCREEN:
            return {
                ...state,
                isScreenGreyedOut: false,
            };
        case OPEN_READING_REMINDER_POPUP:
            return {
                ...state,
                isReadingReminderPopupActive: true,
            };
        case CLOSE_READING_REMINDER_POPUP:
            return {
                ...state,
                isReadingReminderPopupActive: false,
            };
        case SET_IS_SCROLL_BUTTON_CLICKED:
            return {
                ...state,
                isScrollButtonClicked: action.isClicked,
            };
        case ENABLE_TEXT_PANE_SCROLL:
            return {
                ...state,
                isTextPaneScrollEnabled: true,
            };
        case DISABLE_TEXT_PANE_SCROLL:
            return {
                ...state,
                isTextPaneScrollEnabled: false,
            };
        case SET_TRC_CONTENT:
            return {
                ...state,
                fontName: action.content.font_name,
                fontSize: action.content.font_size,
            };
        case SET_CONFIRM_POPUP_VISIBILITY:
            return {
                ...state,
                isConfirmPopupActive: action.isVisible,
            };
        case SHOW_LOGOUT_MODAL:
            return {
                ...state,
                isLogoutModalVisible: true,
            };
        case HIDE_LOGOUT_MODAL:
            return {
                ...state,
                isLogoutModalVisible: false,
            };
        case SHOW_HELP_POPUP:
            return {
                ...state,
                isHelpPopupVisible: true,
            };
        case HIDE_HELP_POPUP:
            return {
                ...state,
                isHelpPopupVisible: false,
            };
        case SET_IS_FILE_LOADING_FAILED:
            return {
                ...state,
                isFileLoadingFailed: action.isFileLoadingFailed,
            };
        case LOAD_PLAYLIST:
            return {
                ...state,
                isAssessmentInstructionEnabled:
                    action.payload.playlists[FIRST_PLAYLIST_INDEX].assessment_type ===
                    ASSESSMENT_TYPE.BM,
            };
        case TOGGLE_POINTER_CLICK:
            return {
                ...state,
                isPointerClicked: !state.isPointerClicked,
            };
        case SET_POINTER_POSITION:
            return {
                ...state,
                pointerPosition: action.position,
            };
        case TOGGLE_POINTER_VISIBILITY:
            return {
                ...state,
                isPointerVisible: !state.isPointerVisible,
            };
        case TOGGLE_CIRCLE_BUTTONS:
            return {
                ...state,
                isCircleButtonsVisible: !state.isCircleButtonsVisible,
            };
        case TOGGLE_SECONDS_TIMER:
            return {
                ...state,
                isSecondsTimerVisible: !state.isSecondsTimerVisible,
            };
        case SET_SECONDS_TIMER:
            return {
                ...state,
                isSecondsTimerActive: action.isActive,
            };
        case SET_CURRENT_LANGUAGE:
            return {
                ...state,
                currentLanguage: action.language,
            };
        case OPEN_TRC_PRACTICE_POPUP:
            return {
                ...state,
                isTRCPracticePopupActive: true,
            };
        case CLOSE_TRC_PRACTICE_POPUP:
            return {
                ...state,
                isTRCPracticePopupActive: false,
            };
        case SHOW_SPINNER:
            return {
                ...state,
                isSpinnerVisible: true,
            };
        case HIDE_SPINNER:
            return {
                ...state,
                isSpinnerVisible: false,
            };
        case SET_IS_EXTERNAL_URL_SOURCE_PRESENT:
            return {
                ...state,
                isExternalURLSourcePresent: true,
            };
        case SET_INITIAL_QUERY_PARAMS:
            return {
                ...state,
                initialQueryParams: action.params,
            };
        case SET_BENCHMARK_MODE_URL_STATUS:
            return {
                ...state,
                isBenchmarkModeEnabled: action.benchmarkMode,
            };
        case SET_AR_LANGUAGE:
            return {
                ...state,
                arLanguage: action.payload,
            };
        case SET_BENCHMARK_ID:
            return {
                ...state,
                benchmarkId: action.id,
            };
        case SET_SHOULD_ENABLE_CAPTIONS:
            return {
                ...state,
                shouldEnableCaptions: true,
            };
        case SET_SHOULD_DISPLAY_CAPTION:
            return {
                ...state,
                shouldDisplayCaption: action.payload,
            };
        case SHOW_PAUSE_BUTTON:
            return {
                ...state,
                shouldShowPauseButton: true,
            };
        case SET_PAUSE_BUTTON_ACTIVE:
            return {
                ...state,
                isPauseButtonActive: true,
            };
        case SET_PAUSE_BUTTON_INACTIVE:
            return {
                ...state,
                isPauseButtonActive: false,
            };
        case SHOW_SETTINGS_POPUP:
            return {
                ...state,
                isSettingsPopupVisible: true,
            };
        case HIDE_SETTINGS_POPUP:
            return {
                ...state,
                isSettingsPopupVisible: false,
            };
        default:
            return state;
    }
};

export default screenReducer;
